import { makeVar } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";

export const apiKeyVar = makeVar<string | null>(null);

export const apiKeyLink = new SetContextLink((prevContext) => {
    const apiKey = apiKeyVar();

    return {
        headers: {
            ...prevContext.headers,
            "X-Api-Key": apiKey ?? "",
        },
    };
});
